// --------------------------------------------------------
// CANCEL MODAL - CancelModal
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import Modal from '@mui/material/Modal'
import { useEffect, useState } from 'react'
import { GenericSolidButton, RedCancelButton } from '../UI/buttons/Button.styled'
import { H1, H2, H3 } from '../UI/generalLayout/Layout.styled'
import { ButtonAreaContainer, Div, InputGroup, ModalContainer, ModalContentContainer, Label } from './editDependenteModal.styled'
import { InputWrapper } from '../loginFields/LoginFields.styled'
import { Auth } from '../../core/http/service/Auth'
import { TextField } from "@mui/material";
import { useAppDispatch } from '../..'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import Colors from '../../constants/Colors'
import moment from "moment";
import Person from '../../models/core/userRole/Person'
import { PersonService } from '../../core/http/service/PersonService'
import GenericModal from '../genericModal/GenericModal'

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CANCEL MODAL INTERFACE
// --------------------------------------------------------


interface ICancelModal {
    Icon?: any;
    visible: boolean;
    user: any;
    onConfirm: any;
    modalTitle: string;
    modalSubtitle: string;
    cancelButtonMsg: string;
    colorButtonCancel?: string;
    colorButtonConfirm?: string;
    confirmButtonMsg: string;
    item: Person | null;
}
  
interface IDependente {
    id: string;    
    nome: string; 
    email: string;
    cpf: string;
    dataNascimento: string;
    idade: string;
    telefoneDependente: string;
    telefones: string [];
    contatoUm: IContato;
    contatoDois: IContato;
}

interface IContato {    
  nome: string;
  email: string;
  telefone: string;
}

/**
/**
 * A component that renders a Cancel modal.
 *
 * @param props The component props.
 * @returns The component JSX.
 */


const EditDependenteModal = ({visible, user, onConfirm, modalTitle, modalSubtitle, cancelButtonMsg, colorButtonCancel, item }: ICancelModal) => {
    // --------------------------------------------------------
    // CANCEL MODAL PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo(); 
    
    const [profile, setProfile] = useState<IDependente>({
        id: '',
        nome: '',
        email: '',
        cpf: '',
        dataNascimento: '',
        idade: '',
        telefones: [],
        telefoneDependente: '',
        contatoUm: { 
            nome: "", 
            email: "", 
            telefone: "" 
          },
        contatoDois: { 
            nome: "", 
            email: "", 
            telefone: "" 
          }
      });

    const [email, setEmail] = useState("")
    const [nome, setNome] = useState("")

    const [textColor, setTextColor] = useState("")
    const [inputEmailShow, setInputEmailShow] = useState(true)
    const [modalTitleModal, setModalTitle]= useState(modalTitle)
    const [modalSubtitleModal, setModalSubtitleModal]= useState(modalSubtitle)
    const [botaoEnviarEmail, setBotaoEnviarEmail]= useState(true)
    const [resposta, setResposta] = useState("")
    const [telefoneErroUm, setTelefoneErroUm] = useState("");
    const [telefoneErroDois, setTelefoneErroDois] = useState("");
    const [showModalSuccess, setShowModalSuccess] = useState(false);
    const [showModalError, setShowModalError] = useState(false);  
    const [showModalSalvar, setShowSalvar] = useState(false);
    const [titleError, setTitleError] = useState("");
   
    const dispatch = useAppDispatch();

    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // ---------------------------
    
    useEffect(() => {        
    
        if(profile?.contatoUm.nome && !profile?.contatoUm.telefone){
          setTelefoneErroUm("Telefone Obrigatório");
        }else{
          setTelefoneErroUm("");
        }
        if(profile?.contatoDois.nome && !profile?.contatoDois.telefone){
          setTelefoneErroDois("Telefone Obrigatório");
        }else{
          setTelefoneErroDois("");
        }
    
      }, [profile?.contatoUm, profile?.contatoDois])


      useEffect(() => {
        if (item) {

          const contatos = Array.isArray(item.contatos) ? item.contatos : [];
    
          const contatosOrdenados = [...contatos].sort((a, b) => {
            const nomeA = a.nome.toLowerCase();
            const nomeB = b.nome.toLowerCase();
            return nomeA.localeCompare(nomeB);
          });
    
          const primeiroContato = contatosOrdenados[0] || { nome: '', email: '', telefone: '' };
          const segundoContato = contatosOrdenados[1] || { nome: '', email: '', telefone: '' };
          setProfile({
            id: item.id || '',
            nome: item.nome || '',
            email: item.email || '',
            cpf: maskCPF(`${item.cpf}`) || '',
            dataNascimento: item.dataNascimento || '',
            idade: calcularIdade(item.dataNascimento) || '',
            telefones: item.telefones || [],
            telefoneDependente: item.telefones && item.telefones.length > 0 ? aplicarMascaraTelefone(item.telefones[0]) : '',
            contatoUm: primeiroContato,
            contatoDois: segundoContato
          });
        }
      }, [item]);

    useEffect(() => {
        if (!visible) {
            setEmail("")            
            setInputEmailShow(true)
            setModalTitle(modalTitle)
            setModalSubtitleModal(modalSubtitle)
            setBotaoEnviarEmail(true)
            setResposta("")
        }
    }, [visible, modalTitle, modalSubtitle])


    function limparString(str: string) {    
        return str.replace(/[^\d]/g, '');
      }

    function aplicarMascaraTelefone(str: string) {
        // Aplicar a máscara (XX) XXXX-XXXX ou (XX) XXXXX-XXXX dependendo do comprimento
    
        if(str){
          const cleaned = limparString(str);
        
          if (cleaned.length === 10) {
            return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
          } else if (cleaned.length === 11) {
            return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
          } else {
            return cleaned;
          }
        }else{
          return "";
        }
      }

    const onConfirmSalvar = async ()=>{
          
        try {            
    
          const service: PersonService = new PersonService();   
          
          let telefones = [];
        
          if (profile && profile.telefones && profile.telefones.length > 0) {        
            telefones = [profile?.telefoneDependente, ...profile.telefones.slice(1)];
          } else {
            telefones = [profile?.telefoneDependente];
          }   
          
          const criarContato = (contato: any) => ({
            grauParentesco: "",
            emergencia: true,
            nome: contato?.nome || "",
            telefone: contato?.telefone || "",
            email: contato?.email || ""
          });
    
          const contatoUmObj = criarContato(profile?.contatoUm);
          const contatoDoisObj = criarContato(profile?.contatoDois);
    
          var person = new Person().fromJSON({
            cpf: profile.cpf,
            nome: profile.nome,
            comoSerChamado: item?.comoSerChamado,
            email: profile?.email, //muda   
            dataNascimento:
            profile.dataNascimento === ""
                ? null
                : moment(profile.dataNascimento).format("YYYY-MM-DD"),            
            telefones: item?.telefones,
            contatos: [],
            id: profile.id, 
          });
    
          const adicionarContatoSeValido = (contato: any) => {
            if (contato.nome && contato.telefone) {
              person?.contatos?.push(contato);
            }
          };
    
          adicionarContatoSeValido(contatoUmObj);
          adicionarContatoSeValido(contatoDoisObj);

            // Validar se existe pelo menos um contato preenchido
            if (!person?.contatos || person.contatos.length === 0) {
                setShowSalvar(false);
                setShowModalError(true);            
                setTitleError('Para continuar, por favor, forneça ao menos um contato válido.');          

            }else{
                var retorno = await service.editPessoaInformation(person);
        
                if(retorno.status == 200){
                setShowSalvar(false);
                setShowModalSuccess(true);        
                }else{
                setTitleError('Erro ao atualizar os dados! Por favor tente mais tarde ou entre em contato com o suporte.');
                setShowModalError(true);
                } 
            }
                        
        } catch (error) {
            console.log(error)
            handleError(error);
            setShowSalvar(false);
            setShowModalError(true);
        }
    
    }

    const handleError = (error: any) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.length > 0
        ) {
          setTitleError(`Erro: ${error.response.data.errors[0]}`);
        } else {
          setTitleError('Erro desconhecido.');
        }
      };
      
      const calcularIdade = (dataNascimento: any): string => {
        const hoje = moment();
        const nascimento = moment(dataNascimento, "YYYY-MM-DD");
      
        const anos = hoje.diff(nascimento, 'years');
        nascimento.add(anos, 'years');
      
        const meses = hoje.diff(nascimento, 'months');
        nascimento.add(meses, 'months');
      
        const dias = hoje.diff(nascimento, 'days');
      
        const resultado = `${anos} ano${anos !== 1 ? 's' : ''}, ${meses} ${meses !== 1 ? 'meses' : 'mês'}, ${dias} dia${dias !== 1 ? 's' : ''}`;
      
        return resultado;
      };

    const maskCPF = (value: string) => {
        return value
          .replace(/\D/g, '')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1.$2') 
          .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      };

      function formatarTelefone(telefone: string) {
        telefone = telefone.replace(/\D/g, '');
      
        // Limita o número de caracteres a 14 (incluindo parênteses, traço e espaço)
        if (telefone.length > 11) {
          telefone = telefone.substring(0, 11);
        }
      
        if (telefone.length === 11) {
          telefone = telefone.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
        } else if (telefone.length === 10) {
          telefone = telefone.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
        } else if (telefone.length === 9) {
          telefone = telefone.replace(/^(\d{5})(\d{4})$/, '$1-$2');
        } else if (telefone.length === 8) {
          telefone = telefone.replace(/^(\d{4})(\d{4})$/, '$1-$2');
        }
      
        return telefone;
      }

    const handleChangeTelefone = (campo: string, e: any) => {
        const telefoneFormatado = formatarTelefone(e.target.value);
        setProfile((prevProfile: any) => ({
            ...prevProfile,
            [campo]: {
            ...prevProfile[campo],
            telefone: telefoneFormatado,
            },
        }));
    };    

    const handleChangeTelefoneDependente = (e: any) => {
        const telefoneFormatado = formatarTelefone(e.target.value);
        setProfile((prevProfile: any) => ({
            ...prevProfile,
            telefoneDependente: telefoneFormatado,
        }));
    };  
            
    return (
        <>
            <Modal
                open={visible}
            >
                <ModalContainer isMobile={isMobile}>
                    <ModalContentContainer isMobile={isMobile} >                        
                        {   
                            isMobile? 
                               <H2 style={{ color: '#0a5190'}}>{modalTitleModal}</H2> 
                            : 
                                <H1 style={{ color: '#0a5190'}}>{modalTitleModal}</H1> 
                        }
                        <InputWrapper style={{ marginTop: 25 }}>
                        <Div>
                            <InputGroup >
                                <Label htmlFor="nome" style={{ alignSelf: 'flex-start'}}>Nome</Label>
                                <TextField
                                    id="nome"
                                    variant="standard"                
                                    value={profile.nome || ''}
                                    onChange={(e: any) => {
                                    setProfile((prevProfile: any) => ({
                                        ...prevProfile,
                                        nome: e.target.value,
                                    }));
                                    }}
                                    type="text"
                                    disabled={true}
                                /> 
                            </InputGroup>

                            <InputGroup>
                                <Label htmlFor="cpf" style={{ alignSelf: 'flex-start'}}>CPF</Label>
                                <TextField
                                    id="cpf"
                                    variant="standard"
                                    value={profile?.cpf}
                                    onChange={(e) => {
                                    setProfile((prevProfile: any) => ({
                                        ...prevProfile,
                                        cpf: e.target.value,
                                    }));
                                    }}
                                    type="text"
                                    disabled={true}
                                />
                            </InputGroup>

                        </Div>

                        <Div>
                            <InputGroup>
                                <Label htmlFor="dataNascimento" style={{ alignSelf: 'flex-start'}}>Data de Nascimento</Label>
                                <TextField
                                    id="dataNascimento"
                                    variant="standard"
                                    value={profile && profile.dataNascimento ? moment(profile?.dataNascimento, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''}
                                    onChange={(e) => {
                                    setProfile((prevProfile: any) => ({
                                        ...prevProfile,
                                        dataNascimento: e.target.value,
                                    }));
                                    }}
                                    type="text"
                                    disabled={true}
                                />
                            </InputGroup>

                            <InputGroup>
                                <Label htmlFor="dataNascimento" style={{ alignSelf: 'flex-start'}}>Idade</Label>
                                <TextField
                                    id="dataNascimento"
                                    variant="standard"
                                    value={profile && profile?.dataNascimento ? calcularIdade(profile?.dataNascimento).toString(): ''}
                                    onChange={(e) => {
                                    setProfile((prevProfile: any) => ({
                                        ...prevProfile,
                                        dataNascimento: e.target.value,
                                    }));
                                    }}
                                    type="text"
                                    disabled={true}
                                />
                            </InputGroup>      
                        </Div>

                        <Div>
                            <InputGroup>
                                <Label htmlFor="email" style={{ alignSelf: 'flex-start'}}>E-mail</Label>
                                <TextField
                                    id="email"
                                    variant="standard"
                                    value={profile?.email || ''}
                                    onChange={(e) => {
                                    setProfile((prevProfile: any) => ({
                                        ...prevProfile,
                                        email: e.target.value,
                                    }));
                                    }}
                                    type="text"                
                                />
                            </InputGroup>               

                            <InputGroup>
                                <Label htmlFor="telefone" style={{ alignSelf: 'flex-start'}}>Telefone para contato</Label>
                                <TextField
                                    id="telefone"
                                    variant="standard"
                                    value={profile?.telefoneDependente || ''}
                                    onChange={(e) => handleChangeTelefoneDependente(e)}
                                    type="text"
                                />
                            </InputGroup>                                 
                        </Div>


                        <div>
                        {/* CONTATO 1 */}
                        <div><H3 style={{ textAlign: 'start' }}>Contato 1</H3></div>
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            <InputGroup style={{ flex: '1 1 30%', margin: '0 10px', textAlign: 'start'  }}>
                            <Label htmlFor="nome1">Nome</Label>
                            <TextField
                                id="nome1"
                                variant="standard"
                                value={profile?.contatoUm.nome || ''}
                                onChange={(e) => {
                                setProfile((prevProfile: any) => ({
                                    ...prevProfile,
                                    contatoUm: {
                                    ...prevProfile.contatoUm,
                                    nome: e.target.value,
                                    },
                                }));
                                }}
                                type="text"
                                disabled={false}
                            />
                            </InputGroup>
                            <InputGroup style={{ flex: '1 1 30%', margin: '0 10px', textAlign: 'start'  }}>
                            <Label htmlFor="email1">E-mail</Label>
                            <TextField
                                id="email1"
                                variant="standard"
                                value={profile?.contatoUm.email || ''}
                                onChange={(e) => {
                                setProfile((prevProfile: any) => ({
                                    ...prevProfile,
                                    contatoUm: {
                                    ...prevProfile.contatoUm,
                                    email: e.target.value,
                                    },
                                }));
                                }}
                                type="text"
                            />
                            </InputGroup>
                            <InputGroup style={{ flex: '1 1 30%', margin: '0 10px', textAlign: 'start'  }}>
                            <Label htmlFor="telefone1">Telefone</Label>
                            <TextField
                                error={telefoneErroUm ? true : false}
                                id="telefone1"
                                variant="standard"
                                value={profile?.contatoUm.telefone || ''}
                                onChange={(e) => handleChangeTelefone('contatoUm', e)}
                                type="text"
                            />
                            {telefoneErroUm && (
                                <span style={{ color: 'red', marginLeft: '5px' }}>{telefoneErroUm}</span>
                            )}
                            </InputGroup>
                        </div>
                        {/* CONTATO 1 */}

                        {/* CONTATO 2 */}
                        <div><H3 style={{ textAlign: 'start' }}>Contato 2</H3></div>
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            <InputGroup style={{ flex: '1 1 30%', margin: '0 10px', textAlign: 'start'  }}>
                            <Label htmlFor="nome2">Nome</Label>
                            <TextField
                                id="nome2"
                                variant="standard"
                                value={profile?.contatoDois.nome || ''}
                                onChange={(e) => {
                                setProfile((prevProfile: any) => ({
                                    ...prevProfile,
                                    contatoDois: {
                                    ...prevProfile.contatoDois,
                                    nome: e.target.value,
                                    },
                                }));
                                }}
                                type="text"
                                disabled={false}
                            />
                            </InputGroup>
                            <InputGroup style={{ flex: '1 1 30%', margin: '0 10px', textAlign: 'start'  }}>
                            <Label htmlFor="email2">E-mail</Label>
                            <TextField
                                id="email2"
                                variant="standard"
                                value={profile?.contatoDois.email || ''}
                                onChange={(e) => {
                                setProfile((prevProfile: any) => ({
                                    ...prevProfile,
                                    contatoDois: {
                                    ...prevProfile.contatoDois,
                                    email: e.target.value,
                                    },
                                }));
                                }}
                                type="text"
                            />
                            </InputGroup>
                            <InputGroup style={{ flex: '1 1 30%', margin: '0 10px', textAlign: 'start' }}>
                            <Label htmlFor="telefone2">Telefone</Label>
                            <TextField
                                error={telefoneErroDois ? true : false}
                                id="telefone2"
                                variant="standard"
                                value={profile?.contatoDois.telefone || ''}
                                onChange={(e) => handleChangeTelefone('contatoDois', e)}
                                type="text"
                            />
                            {telefoneErroDois && (
                                <span style={{ color: 'red', marginLeft: '5px' }}>{telefoneErroDois}</span>
                            )}
                            </InputGroup>
                        </div>
                        {/* CONTATO 2 */}
                        </div>
                   

                        </InputWrapper>

                        {
                       
                            <>
                                <ButtonAreaContainer style={{ marginTop: 35 }}>
                                    <RedCancelButton
                                    color={colorButtonCancel ? colorButtonCancel : ""}
                                        onClick={onConfirm}
                                    >
                                        {cancelButtonMsg}
                                    </RedCancelButton> <br/>
                                    <GenericSolidButton color={Colors.SPM600} onClick={() => setShowSalvar(true)}>
                                        Salvar
                                    </GenericSolidButton>
                                </ButtonAreaContainer>   
                                {
                                    resposta ? 
                                        <span style={{color: textColor, marginTop: 15, fontWeight: 'bold'}}>{resposta}</span> 
                                    : 
                                        ''
                                }  
                            </>

                        }
                        <br/>
                    
                    </ModalContentContainer>
                </ModalContainer>
            </Modal>

            <GenericModal                 
                visible={showModalSalvar} 
                onCancel={onConfirmSalvar} 
                onConfirm={ () => setShowSalvar(false)} 
                modalTitle={'Tem certeza de que deseja salvar as alterações no seu perfil? Verifique se todas as informações estão corretas antes de prosseguir.'} 
                modalSubtitle={''} 
                cancelButtonMsg={'Voltar'} 
                confirmButtonMsg={'Confirmar'}                
            />
            
            <GenericModal                 
                visible={showModalSuccess} 
                onCancel={() => setShowModalSuccess(false)} 
                onConfirm={() => setShowModalSuccess(false)} 
                modalTitle={'Operação concluída com sucesso! Os dados foram atualizados com êxito.'} 
                modalSubtitle={''} 
                cancelButtonMsg={''} 
                confirmButtonMsg={'Ok'}                
            />    

            <GenericModal                 
                visible={showModalError} 
                onCancel={() => setShowModalError(false)} 
                onConfirm={() => setShowModalError(false)} 
                modalTitle={titleError} 
                modalSubtitle={''} 
                cancelButtonMsg={''} 
                confirmButtonMsg={'Ok'}                
            />               
        </>
    )
    // --------------------------------------------------------

}

export default EditDependenteModal